module.exports = __webpack_public_path__ + "static/img/bannerBg1.ac259df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bannerBg1.png
// module id = j3YQ
// module chunks = 1